<template>
  <div
    class="usp-app-video-player bg-g"
    v-if="moduleData.videoLeft || moduleData.videoRight"
  >
    <div class="usp-app-video-player-item">
      <div class="usp-app-video-player-item-video">
        <div
          class="usp-app-video-player-item-video-mask"
          @click="playVideo('videoLeft')"
          :class="{ hide }"
        >
          <div class="play-btn"></div>
        </div>
        <div class="usp-app-video-player-item-video-poster"></div>
        <video
          preload
          autoplay
          muted="muted"
          :class="{ hide }"
          class="usp-video usp-app-video-player-item-video-img"
          webkit-playsinline
          playsinline
          loop="loop"
          id="videoLeft"
          poster="https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20220825165541450-iphone.png"
        >
          <!-- muted="muted" -->
          <source :src="moduleData.videoLeft" type="video/mp4" />
        </video>
      </div>
      <div class="usp-app-video-player-item-data">
        <div class="usp-app-video-player-item-data-title">
          {{ moduleData.videoLeftTitle }}
        </div>
        <div class="usp-app-video-player-item-data-desc">
          {{ moduleData.videoLeftDes }}
        </div>
      </div>
    </div>
    <div class="usp-app-video-player-item">
      <div class="usp-app-video-player-item-video">
        <div
          class="usp-app-video-player-item-video-mask"
          @click="playVideo('videoRight')"
          :class="{ hide }"
        >
          <!-- :class="{ hide}" -->
          <div class="play-btn"></div>
        </div>
        <div
          class="usp-app-video-player-item-video-poster"
          :class="{ hide }"
        ></div>
        <video
          preload
          muted="muted"
          autoplay
          class="usp-video usp-app-video-player-item-video-img"
          webkit-playsinline
          playsinline
          loop="loop"
          id="videoRight"
          poster="https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20220825165541450-iphone.png"
        >
          <!-- muted="muted" -->
          <source :src="moduleData.videoRight" type="video/mp4" />
        </video>
      </div>
      <div class="usp-app-video-player-item-data">
        <div class="usp-app-video-player-item-data-title">
          {{ moduleData.videoRightTitle }}
        </div>
        <div class="usp-app-video-player-item-data-desc">
          {{ moduleData.videoRightDes }}
        </div>
      </div>
    </div>
    <!-- <div class="usp-app-video-player-item" v-for="(item, index) in videos" :key="index">
      <div class="usp-app-video-player-item-video">
        <div
          class="usp-app-video-player-item-video-mask"
          @click="playVideo(index)"
          :class="{ hide: item.isPlay }"
        >
          <div class="play-btn"></div>
        </div>
        <div
          class="usp-app-video-player-item-video-poster"
          :class="{ hide: item.isPlayed }"
          :style="'background-image:url(' + item.poster + ');'"
        ></div>
        <video
          preload
          muted="muted"
          :class="{ hide: item.isPlay }"
          class="usp-video usp-app-video-player-item-video-img"
          webkit-playsinline
          playsinline
          loop="loop"
        >
          <source :src="item.video" type="video/mp4" />
        </video>
      </div>
      <div class="usp-app-video-player-item-data">
        <div class="usp-app-video-player-item-data-title">{{ item.title }}</div>
        <div class="usp-app-video-player-item-data-desc">{{ item.desc }}</div>
      </div>
    </div> -->
  </div>
</template>
<script>
export default {
  name: "moreVideoScreen",
  props: {
    moduleData: {
      type: Object,
    },
  },
  data() {
    return {
      hide: "hide",
    };
  },
  mounted() {},
  methods: {
    playVideo(el) {
      let baseVideo = document.getElementById(el);
      if (baseVideo) {
        baseVideo.paused ? baseVideo.play() : baseVideo.pause();
      }
    },
  },
};
</script>
<style lang="scss">
@import "@style/base";
@import "@style/common";
.usp-app-video-player {
  padding-top: 16px;
  padding-bottom: vw(100);
  margin: 0 -8px;
  display: flex;
  align-items: flex-start;
  @include media(
    (
      $home-md: (
        padding-top: 0,
        padding-bottom: 60px,
      ),
      $home-sm: (
        display: block,
        padding-bottom: 40px,
      ),
    )
  );
  .usp-app-video-player-item + .usp-app-video-player-item {
    @include media(
      (
        $home-sm: (
          margin-top: 40px,
        ),
      )
    );
  }
  .usp-app-video-player-item {
    padding: 0 8px;
    width: 50%;
    box-sizing: border-box;
    @include media(
      (
        $home-sm: (
          width: 100%,
          display: block,
        ),
      )
    );
    .usp-app-video-player-item-video {
      position: relative;
      overflow: hidden;
      cursor: pointer;
      @include setThemeClass {
        &:hover {
          .usp-app-video-player-item-video-mask {
            background-color: getThemeVal(brandColorBlackOpacity4);
          }
          .usp-app-video-player-item-video-poster {
            transform: scale(1.1, 1.1);
            @include media(
              (
                $home-sm: (
                  transform: none,
                ),
              )
            );
          }
        }
      }

      .usp-app-video-player-item-video-mask {
        opacity: 1;
        &.hide {
          opacity: 0;
        }
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: transparent;
        transition: background-color 0.5s $easeOutCubic,
          opacity 0.5s $easeOutCubic;
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 2;
        .play-btn {
          width: 50px;
          height: 50px;
          background: setBgImg(
            "https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20210628182137368-web_usp_vdo@2x.png",
            contain
          );
        }
      }
      .usp-app-video-player-item-video-poster {
        &.hide {
          opacity: 0;
        }
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        z-index: 1;
        background: no-repeat center center/cover;
        transition: transform 0.5s $easeOutCubic;
      }
      .usp-app-video-player-item-video-img {
        display: block;
        width: 100%;
        height: auto;
        object-fit: cover;
        &.hide {
          transform: none;
        }
        @include media(
          (
            $home-sm: (
              height: 250px,
              display: block,
            ),
          )
        );
      }
    }
    .usp-app-video-player-item-data {
      text-align: center;
      @include setThemeClass {
        .usp-app-video-player-item-data-title {
          margin-top: vw(60);
          @include h2(getThemeVal(brandColorBlack), vw);
          @include media(
            (
              $home-md: (
                margin-top: 30px,
                font-size: 28px,
                line-height: 42px,
              ),
            )
          );
        }
        .usp-app-video-player-item-data-desc {
          margin-top: vw(20);
          @include h3-s(getThemeVal(brandColorBlack), vw);
          @include media(
            (
              $home-md: (
                margin-top: 10px,
                font-size: 14px,
                line-height: 30px,
              ),
            )
          );
        }
      }
    }
  }
}
</style>
